export const colors = {
  blue: {
    dark: "#006997",
    light: "#00a4ec",
    navy: "#034980",
  },
  gray: {
    border: "#e8e8e8",
    dark: "#646464",
    light: "#f9f9f9",
    middle: "#a0aec0",
  },
  green: "#38a169",
  orange: {
    dark: "#ff7a59",
    light: "#fef4f1",
  },
  red: "#e53e3e",
  transparent: "transparent",
  white: "#ffffff",
};

export const bannerGradient = "linear-gradient(to right, #049be7 0%,#281496 100%);";

export const brandColors = {
  /**
   * Brand Light Blue
   */
  accent: colors.blue.light,
  /**
   * Brand Orange
   */
  primary: colors.orange.dark,
  /**
   * Brand Dark Blue
   */
  secondary: colors.blue.navy,
  /**
   * Brand White
   */
  tertiary: colors.white,
};

export const statusColors = {
  disabled: colors.gray.middle,
  error: colors.red,
  success: colors.green,
};

export const textColors = {
  contrast: colors.white,
  default: colors.gray.dark,
  faded: colors.gray.middle,
  heading: colors.blue.navy,
  link: colors.blue.dark,
};

export const buttonColors = {
  primary: {
    background: brandColors.primary,
    border: brandColors.primary,
    text: brandColors.tertiary,
    // Hover effects should be listed after defaults
    // eslint-disable-next-line sort-keys
    hover: {
      background: brandColors.accent,
      border: brandColors.accent,
    },
  },
  secondary: {
    background: brandColors.tertiary,
    border: brandColors.primary,
    text: brandColors.primary,
    // Hover effects should be listed after defaults
    // eslint-disable-next-line sort-keys
    hover: {
      background: brandColors.primary,
      text: brandColors.tertiary,
    },
  },
  tertiary: {
    background: colors.transparent,
    border: colors.transparent,
    // Tertiary buttons are intended to appear as links, so the link's color is referred here
    // to ensure they remain in sync.
    text: textColors.link,
  },
};

export const textInputColors = {
  background: colors.gray.light,
  border: colors.gray.border,
  focus: brandColors.primary,
  placeholderText: textColors.default,
  // Form inputs use the default text color
  text: textColors.default,
};
